import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

export default class LineChart extends Component {

  render() {
    return (
      <div className="chart">
        <Bar ref='chart'
          data={this.props.chartData}
          options={{
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    max: 10,
                    fontFamily: 'Gilroy-Bold',
                    fontColor: '#000000'
                  },
                  gridLines: {
                    borderDash: [4, 4],
                    color: 'rgba(#ffffff,0.8)'
                  },
                }
              ],
              xAxes: [
                {
                  ticks: {
                    fontFamily: 'Gilroy-Bold',
                    fontColor: '#000000',
                  },
                  barPercentage: 1,
                  categoryPercentage: 0.3,
                }
              ]
            },
            legend: {
              display: false
            },
            tooltips: {
              enabled: false
            },
            plugins: {
              dataset: {
                datalabels: {
                  display: true,
                  colors: [
                    '#3413B1',
                    '#FD713C',
                  ],
                  font: {
                    family: 'Gilroy-Bold',
                    size: '16'
                  },
                  anchor: 'end',
                  padding: {
                    bottom: 8
                  }
                }
              }
            }
          }}
        />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/screens/AssessmentReport/components/LineChart/LineChart.js